import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AttributedTextComponent from './AttributedTextComponent';

class TextComponent extends Component {

  render() {
    return (
      <p Style={this.stringForStyle(this.props.style)}>
        {
          this.props.items.map((item, index) => (
            <AttributedTextComponent style={item.style} text={item.text} type={item.type} href={item.href}/>))
        }
      </p>
      )
  }

   stringForStyle(style) {
    var styleString = "";
    for (var key in style) {
        styleString += key+':'+style[key]+';';
    }
    return styleString;
 }

}

export default TextComponent;


// WEBPACK FOOTER //
// ./src/reusable_components/page_components/Text/TextComponent.jsx